<template>
    <div class="my-2" :class="containerClass">
        <slot></slot>
        <div
            @click="click($event, value)"
            @keyup.enter="$emit('update:value', (value = !value))"
            :aria-labelledby="name"
            class="flex flex-row gap-2 cursor-pointer select-none"
            tabindex="0"
        >
            <div :class="value ? 'text-blue border-blue bg-blue-light' : 'text-blue-dark border-gray-300 bg-white-light'" class="flex-none rounded-md border px-1">
                <span class="mt-0.5 text-xxs" v-html="label" />
            </div>
        </div>
        <FormError :formComponentId="formComponentId" :name="name" v-model:status="status" />
    </div>
</template>

<script>
export default {
    props: {
        value: Boolean,
        label: String,
        name: String,
        containerClass: String,
        formComponentId: ''
    },

    emits: ['update:value'],

    data: () => ({
        status: null
    }),

    methods: {
        click(el, value) {
            // only trigger click if its not a link
            if (el.target.nodeName != 'A') {
                this.$emit('update:value', (value = !value));
            }
        }
    }
};
</script>
